<template>
  <div>
    <navigation />
    <section class="section is-medium" id="privacy">
      <div class="container">
        <div class="content">
          <h1 class="title is-2 is-size-4-mobile">
            {{ $t('views.banner.2026-02-27.text') }}
          </h1>
          <hr class="is-placeholder is-hidden-mobile" />
          <div class="columns">
            <div class="column is-one-quarter">
              <img
                class="mb-5"
                src="../assets/RepGuide-Notebook-Tablet-Phone-Lukas.png"
                alt="Rep.Guide Screenshot"
              />
            </div>
            <div class="column">
              <p class="is-size-5">
                <i18n path="views.meeting.description.text">
                  <strong>{{ $t("views.meeting.description.future") }}</strong>
                  <strong>{{
                    $t("views.meeting.description.database")
                  }}</strong>
                  {{ store.totalMachineCount }}
                </i18n>
              </p>
              <a
                v-if="callToAction"
                :href="callToAction"
                target="_blank"
                class="button is-primary"
              >
                {{ $t('views.banner.cta') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footerNavigation />
  </div>
</template>

<script>
import footerNavigation from "../components/footerNavigation.vue";
import navigation from "../components/navigation.vue";
import { store } from "../store";
import { nextWebinar, webinarLink } from "../webinars";

export default {
	name: "impressum",
	components: {
		navigation,
		footerNavigation,
	},
	data() {
		return {
			store,
		};
	},
  computed: {
    callToAction() {
      const countryCode = store.selectedPartner?.AppCountry?.country_code

      return webinarLink(nextWebinar(), countryCode)
    },
  }
};
</script>
